// Reuse the canonical store-settings currency list and helpers
import { getCurrencies, findCurrency } from '../../BusinessSuite/store/store_settings/utils/currencyList';

export const CURRENCIES = getCurrencies();

export const curMeta = (code) => {
  // Prefer the canonical finder, fall back to local list item if available
  const meta = findCurrency(code) || CURRENCIES.find(c => c.code === code);
  if (!meta) throw new Error('Currency not selected');
  // Normalize shape to { code, symbol, decimals }
  const decimals = typeof meta.digits === 'number' ? meta.digits : (typeof meta.decimals === 'number' ? meta.decimals : 2);
  const symbol = meta.symbol || meta.symbol_native || meta.code;
  return { code: meta.code, symbol, decimals };
};

/** Minor-units ➜ formatted string ("€ 12.50") */
export const fmtMoney = ({ amount = 0, currency = 'EUR' }) => {
  const { symbol, decimals } = curMeta(currency);
  const value = (amount / 10 ** decimals).toFixed(decimals);
  return `${symbol}\u00A0${value}`;
};

/** Cast string input ("12.5" or "12,50") ➜ { amount, currency }
 *  Returns `amount` in minor-units (integer) consistent with store-settings digits
 */
export const parseInputPrice = (str, currency = 'EUR') => {
  const { decimals } = curMeta(currency);
  const s = String(str || '').trim();
  if (s === '') return { amount: 0, currency };
  // normalize comma decimal separator
  const normalized = s.replace(/,/g, '.');
  // remove any characters except digits, dot and minus
  const cleaned = normalized.replace(/[^0-9.\-]/g, '');
  if (cleaned === '' || cleaned === '.' || cleaned === '-') return { amount: 0, currency };
  const num = Number(cleaned);
  if (Number.isNaN(num)) return { amount: 0, currency };
  const asFixed = num.toFixed(decimals);
  return {
    amount: Math.round(Number(asFixed) * 10 ** decimals),
    currency,
  };
};
